import React, { useState } from "react";
import CustomSearch from "../../components/common/CustomSearch";
import ServerPaginationDataGridWithReactQuery from "../../components/common/CustomDataGrid/ServerPaginationDataGridWithReactQuery";
import { getBecomeAdvisor } from "../../utils/urls";

const columns = [
  { field: "name",           headerName: "Advisor Name" },
  { field: "contact_number", headerName: "Mobile Number" },
  { field: "email",          headerName: "Email" },
  {
    field: "created_at",
    headerName: "Applied On",
    renderCell: (params) =>
      new Date(params.created_at).toLocaleDateString("en-GB", {
        day: "numeric", month: "short", year: "numeric",
      }),
  },
];

const BecomeAdvisor = () => {
  const [search, setSearch] = useState("");

  return (
    <div className="min-h-screen bg-[#F8FAFC] p-1 flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-xl font-bold text-[#0F172A]">Become Advisor</h1>
          <p className="text-sm text-[#64748B] mt-0.5">Applications from prospective advisors</p>
        </div>
        <div className="w-64">
          <CustomSearch placeholder="Search advisors..." onChange={setSearch} />
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 flex-1 overflow-hidden">
        <ServerPaginationDataGridWithReactQuery
          url={getBecomeAdvisor}
          requestParameter={{}}
          limit={10}
          search={search}
          columns={columns}
          isServerPagination={true}
          dataMapper={(list) => list}
        />
      </div>
    </div>
  );
};

export default BecomeAdvisor;
